import Dashboard from './components/Dashboard';

export default Dashboard;


// WEBPACK FOOTER //
// ./routes/app/routes/dashboard/index.js